import styled, { css } from 'styled-components';
import { themeable } from 'themes/utils';
import { TextM, TextXS, TextMBig } from 'ui/Styled/Styled';
import {
    notDesktopMediaQuery,
    onlyTabletMediaQuery,
    mobileMediaQuery
} from 'utils/mediaQuery';

export const ServiceCardWrapper = styled.div<{ $disabled?: boolean }>`
    background: ${themeable('bodyBackgroundColor')};
    border-radius: 12px;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    color: ${themeable('primaryColor')};
    cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
    ${onlyTabletMediaQuery(css`
        padding-left: 12px;
        padding-right: 12px;
    `)}

    ${mobileMediaQuery(css`
        padding-left: 10px;
        padding-right: 10px;
    `)}
`;

export const InfoCardWrapper = styled(ServiceCardWrapper).attrs({
    $disabled: true
})`
    padding: 16px;
`;

export const No = styled.div`
    width: 32px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 2px solid ${themeable('primaryColor')};
    margin-right: 16px;
    font-weight: 500;
    font-size: 18px;

    ${notDesktopMediaQuery(css`
        margin-right: 12px;
    `)}
`;

export const ServiceCardText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    margin-right: 10px;
`;

export const ServiceCardTitle = styled(TextM)``;

export const ServiceCardDescription = styled(TextXS)`
    max-width: 24em;
`;

export const ServiceCardPrice = styled(TextMBig)`
    color: ${themeable('textColor')};
    margin-left: auto;
    text-align: right;
`;

export const Container = styled.div`
    display: grid;
    gap: 16px;
`;
